import CodeMirror from "@uiw/react-codemirror";
import { vscodeDark } from "@uiw/codemirror-theme-vscode";
import "./CodeEditor.scss";
import TestCaseRightIcon from "../../../../utils/Images/TestCaseRightIcon";
import TestCaseWrongIcon from "../../../../utils/Images/TestCaseWrongIcon";
import { AssessmentButton, TypeSelect } from "ui-components";
import { compileApplicantQuestion } from "../../../../service/SubmitAssessment/SubmitAssessment";
import Draggable from "react-draggable";
import StartCamera from "../StartCamera";
import { useTranslation } from "react-i18next";
import { convertToText, isSafari } from "../../../../utils/Common/Constant";
import { forwardRef, useRef, useState } from "react";
import Loader from "../../../../components/Loader/Loader";
import StartSafariCamera from "../StartSafariCamera";
interface CodeEditor {
  questionData: any;
  codingAnsTemplate: string;
  setCodingAnsTemplate: any;
  codeOutPut: any;
  testCases: any;
  setTestCases: any;
  setCodeOutput: any;
  timer: number;
  currentQuestionIndex: number;
  questionId: string;
  handleSubmitAnswer?: any;
  setStartQuestionLoader: any;
  startQuestionLoader: boolean;
  SetIsCodingQuestionEdited: any;
  isStartRecording: boolean;
  cameraStopped: boolean;
  setCodingSummary: any;
  setDisableNext: any;
  selectedLanguage: string;
  setSelectedLanguage: any;
}
const CodeEditor: React.ForwardRefRenderFunction<any, CodeEditor> = (
  {
    questionData,
    codingAnsTemplate,
    setCodingAnsTemplate,
    codeOutPut,
    testCases,
    setTestCases,
    setCodeOutput,
    timer,
    currentQuestionIndex,
    questionId,
    handleSubmitAnswer,
    setStartQuestionLoader,
    startQuestionLoader,
    SetIsCodingQuestionEdited,
    isStartRecording,
    cameraStopped,
    setCodingSummary,
    setDisableNext,
    selectedLanguage,
    setSelectedLanguage,
  },
  ref,
) => {
  const { t } = useTranslation();
  const handleCompilerChange = (code: string) => {
    SetIsCodingQuestionEdited(true);
    setCodingAnsTemplate(code);
  };
  const draggableRef = useRef<any>(null);
  const [runLoading, setRunLoading] = useState(false);
  const handleRun = async () => {
    setRunLoading(true);
    const runData = {
      questionId: questionData?.questionId,
      languageId: questionData?.metaData?.languageId,
      sourceCode: btoa(codingAnsTemplate),
      skillName:
        questionData?.skillName === "Coding-NA"
          ? selectedLanguage
          : questionData?.skillName,
    };
    const runRes = await compileApplicantQuestion(runData);
    if (runRes?.data?.status === 200) {
      setCodeOutput(
        runRes?.data?.data?.user_output
          ? convertToText(runRes?.data?.data?.user_output)
          : "",
      );
      setCodingSummary(runRes?.data?.data);
      setTestCases(runRes?.data?.data?.code_correctness);
      setDisableNext(false);
    }
    setRunLoading(false);
  };
  const languages = [
    { label: "Java", value: "java" },
    { label: "C", value: "c" },
    { label: "C++", value: "c++" },
    { label: "Python", value: "python" },
    { label: "PHP", value: "php" },
    { label: "JavaScript", value: "js" },
    { label: "Dart", value: "dart" },
  ];
  return (
    <>
      <Draggable
        bounds="parent"
        defaultPosition={{ x: 700, y: 150 }}
        nodeRef={draggableRef}
      >
        <div className="box" ref={draggableRef}>
          {isSafari() ? (
            <StartSafariCamera
              ref={ref}
              timer={timer}
              currentQuestionIndex={currentQuestionIndex}
              questionId={questionId}
              isCodingQuestion={true}
              data={questionData}
              handleSubmitAnswer={handleSubmitAnswer}
              setStartQuestionLoader={setStartQuestionLoader}
              startQuestionLoader={startQuestionLoader}
              isStartRecording={isStartRecording}
              cameraStopped={cameraStopped}
            />
          ) : (
            <StartCamera
              ref={ref}
              timer={timer}
              currentQuestionIndex={currentQuestionIndex}
              questionId={questionId}
              isCodingQuestion={true}
              data={questionData}
              handleSubmitAnswer={handleSubmitAnswer}
              setStartQuestionLoader={setStartQuestionLoader}
              startQuestionLoader={startQuestionLoader}
              isStartRecording={isStartRecording}
              cameraStopped={cameraStopped}
            />
          )}
        </div>
      </Draggable>
      <div className="runBtn">
        <AssessmentButton
          onClick={() => {
            handleRun();
          }}
          disabled={runLoading || codingAnsTemplate.length <= 0}
        >
          {runLoading ? (
            <div className="disableLoading d-flex align-items-center gap-2">
              {t("GENERAL.LOADING")}
              <Loader />
            </div>
          ) : (
            t("GENERAL.RUN")
          )}
        </AssessmentButton>
      </div>
      <div className="parent">
        <div className="editor">
          {questionData?.skillName === "Coding-NA" && (
            <div className="languageSelect">
              <TypeSelect
                options={languages}
                value={selectedLanguage}
                placeholder={t("GENERAL.SELECT_LANGUAGE")}
                onChange={(e: string) => setSelectedLanguage(e)}
              />
            </div>
          )}
          <CodeMirror
            value={codingAnsTemplate}
            // readOnly={setStartQuestionLoader}
            height="400px"
            theme={vscodeDark}
            onChange={(get) => {
              handleCompilerChange(get);
            }}
          />
        </div>
        <div className="transScriptSec">
          <div className="resultSec">
            {t("GENERAL.RESULT")}
            <div className="resultContentSec">
              <div
                dangerouslySetInnerHTML={{ __html: codeOutPut }}
                className="resultContent"
              />
              {codeOutPut && (
                <div className={`icon ${testCases ? "bgGreen" : "bgRed"}`}>
                  {testCases ? <TestCaseRightIcon /> : <TestCaseWrongIcon />}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default forwardRef(CodeEditor);
